import React, { useState } from "react";
import {
  Box,
  Flex,
  Image,
  keyframes,
  useBreakpointValue,
} from "@chakra-ui/react";
import loginImage from "./images/landing-hero.jpg";
import { SignUp } from "./components/SignUp";
import { SignIn } from "./components/SignIn";
import { ForgotPassword } from "./components/ForgotPassword";
import { AuthLogin } from "./components/AuthLogin";
import { NewPassword } from "./components/NewPassword";
import OvendLogo from "../../components/nav/components/OvendLogo";

const containerEntrance = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const formEntrance = keyframes`
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Login = () => {
  const [signUpp, setSignUpp] = useState("signin");
  const [email, setEmail] = useState("");
  const [resetToken, setResetToken] = useState("");
  const showHero = useBreakpointValue({ base: false, lg: true });

  return (
    <Box maxH="100vh" bg="white" overflow={["auto", "auto", "hidden"]}>
      <Flex
        direction={["column", "column", "row"]}
        maxH="100vh"
        w={"100%"}
        alignItems="stretch"
      >
        {showHero && (
          <Box
            w={["100%", "45%", "40%"]}
            h={{ md: "100vh" }}
            maxH={{ md: "100vh" }}
            position="relative"
            overflow="hidden"
          >
            <Image
              src={loginImage}
              alt="login Image"
              w="100%"
              h="auto"
              objectFit="contain"
              objectPosition="center"
            />
          </Box>
        )}
        <Box position="absolute"  top="16px" left="16px" zIndex="10">
          <OvendLogo />
        </Box>
        <Flex
          w={["100%", "65%", "60%"]}
          justify="center"
          marginInline={"auto"}
          align="center"
          px={["16px", "24px", "40px"]}
          mt={["50px", "10px"]}
          
          mb="50px"
          animation={`${containerEntrance} 0.55s ease-out`}
        >
          <Box
            w="100%"
            h="100%"
            maxW={["100%", "620px"]}
            borderRadius="20px"
            bg={"transparent"}
            overflowY={"auto"}
            marginInline={"auto"}
          >
            <Box key={signUpp} animation={`${formEntrance} 0.4s ease-out`}>
              {signUpp === "signup" && <SignUp setSignUpp={setSignUpp} />}
              {signUpp === "signin" && (
                <SignIn
                  setSignUpp={setSignUpp}
                  email={email}
                  setEmail={setEmail}
                />
              )}
              {signUpp === "forgot" && (
                <ForgotPassword setSignUpp={setSignUpp} setEmail={setEmail} />
              )}
              {signUpp === "authlogin" && (
                <AuthLogin
                  setSignUpp={setSignUpp}
                  email={email}
                  setResetToken={setResetToken}
                />
              )}
              {signUpp === "newpassword" && (
                <NewPassword
                  setSignUpp={setSignUpp}
                  email={email}
                  resetToken={resetToken}
                />
              )}
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
